// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__2Ckv3","container":"styles_container__1KvTQ","paper":"styles_paper__1_T7L","logoBig":"styles_logoBig__3L5Dp","logoSmall":"styles_logoSmall__3fQ-X"};